import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: 'https://prd-cloud.agvperu.com', // PRD
  // baseURL: 'https://backend-qas.agvperu.com/backend' // QAS,
  // baseURL: 'http://localhost:8000', // Local,
  // timeout: 300000,
  withCredentials: true,
})

Vue.prototype.$http = axiosIns

export default axiosIns
